/**
 * Manage KlaviyoForm submissions
 *
 */
class customKlaviyo extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.successMsg = this.form.getAttribute("data-successmsg");
    this.subscribed = this.form.getAttribute("data-subscribed");
    this.responseInput = this.querySelector("[data-final-result]");

    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  /**
   * Klaviyo Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const formURL =
      this.form.getAttribute("data-ajax-submit") ||
      this.form.getAttribute("action");
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    // Validation Code
    const listID = this.form.querySelector('[name="g"]').value;
    const emailID = this.form.querySelector('[name="email"]').value;
    if (emailID.trim().length <= 0) {
      this.responseInput.innerHTML = "Empty Email";
      this.manageResponseText(this.responseInput);
      return;
    } else if (!this.validateEmail(emailID)) {
      this.responseInput.innerHTML = "Invalid Email";
      this.manageResponseText(this.responseInput);
      return;
    } else if (listID == null || listID.length <= 0) {
      this.responseInput.innerHTML = "Invalid List ID";
      this.manageResponseText(this.responseInput);
      return;
    }

    const data = new URLSearchParams();
    for (const pair of new FormData(this.form)) {
      data.append(pair[0], pair[1]);
    }

    fetch(formURL, {
      method: "post",
      body: data,
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.success == false) {
          const errortext = parsedState.errors[0];
          this.responseInput.innerHTML = errortext;
          this.manageResponseText(this.responseInput);
        } else if (
          parsedState.success == true &&
          parsedState.data.is_subscribed == true
        ) {
          this.responseInput.innerHTML = this.subscribed;
          this.manageResponseText(this.responseInput);
        } else {
          this.form.querySelector('[name="email"]').value = "";
          this.responseInput.innerHTML = this.successMsg;
          this.manageResponseText(this.responseInput);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove("loading");
        submitButton.removeAttribute("disabled");
      });
  }

  manageResponseText(element) {
    Utility.fadeEffect(element, "fadeIn");
    setTimeout(() => {
      Utility.fadeEffect(element, "fadeOut");
    }, 3000);
  }

  /**
   * Email Validation
   * @param {*} email
   */
  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
}
customElements.define("custom-klaviyo", customKlaviyo);

/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
 class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];
    
    // Check if this dropdown is in a mobile navigation drawer
    // Mobile drawers should only use click/touch events, not hover
    this.isMobileMenu = this.dropdown.closest('.mobile-nav-drawer') !== null || 
                        this.dropdown.closest('.navbar-mobile') !== null;

    this.init();
  }

  init() {
    // Add keyboard support for dropdown toggle
    this.toggleCTA.addEventListener('keydown', (evt) => {
      if (evt.key === 'ArrowDown') {
        evt.preventDefault();
        if (!this.dropdown.classList.contains('open')) {
          this.dropdownShow(this.dropdown);
        }
        // Focus first tab or link in dropdown
        const firstTab = this.dropdown.querySelector('[role="tab"]');
        const firstLink = this.dropdown.querySelector('.dropdown-menu a[tabindex="0"], .dropdown-menu a:not([tabindex="-1"])');
        const focusTarget = firstTab || firstLink;
        if (focusTarget) {
          setTimeout(() => focusTarget.focus(), 50);
        }
      } else if (evt.key === 'Escape' && this.dropdown.classList.contains('open')) {
        evt.preventDefault();
        this.dropdownHide(this.dropdown);
        this.toggleCTA.focus();
      }
      // For Enter/Space: Allow default navigation for parent links
      // Only prevent default for dropdowns that should toggle
      else if ((evt.key === 'Enter' || evt.key === ' ') && this.toggleCTA.dataset.toggle === 'dropdown') {
        evt.preventDefault();
        this.toggleDropdown();
        setTimeout(() => {
          const firstTab = this.dropdown.querySelector('[role="tab"]');
          const firstLink = this.dropdown.querySelector('.dropdown-menu a[tabindex="0"]');
          const focusTarget = firstTab || firstLink;
          if (focusTarget) {
            focusTarget.focus();
          }
        }, 100);
      }
    });

    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          // For parent links (like "Shop" > "Suspension"), allow navigation on direct click
          // But prevent default if it's a right-click or modifier key (to allow opening in new tab)
          if (this.toggleCTA.tagName === 'A' && this.toggleCTA.dataset.parentLink && 
              (evt.ctrlKey || evt.metaKey || evt.shiftKey || evt.button === 1)) {
            // Allow default behavior for modifier keys (open in new tab/window)
            return;
          }
          // For megamenu tabs, toggle dropdown instead of navigating
          if (this.dropdown.classList.contains('megamenu_tab')) {
            evt.preventDefault();
            this.toggleDropdown();
          }
          // For regular dropdowns, prevent default to show menu
          else if (this.toggleCTA.dataset.toggle === 'dropdown' || this.toggleCTA.dataset.toggle === 'open') {
            evt.preventDefault();
            this.toggleDropdown();
          }
          // Otherwise, allow link navigation
        });
      } else if(type === 'mouseenter') {
        // Only bind hover events for desktop menus, not mobile navigation
        if (!this.isMobileMenu) {
          this.toggleCTA.addEventListener(type, (evt) => {
              this.dropdownShow(this.dropdown);
          });
          this.toggleCTA.addEventListener(type, (_evt) => {
            this.childOnFocusChange(this.dropdown);
          });
        }
      } else if (type === "mouseleave") {
        // Only bind hover events for desktop menus, not mobile navigation
        if (!this.isMobileMenu) {
          this.dropdown.addEventListener(type, (evt) => {
            // Check if the related target is another dropdown menu or part of a dropdown menu
            // This prevents the menu from closing when moving diagonally to submenu items
            if (!evt.relatedTarget || !evt.relatedTarget.closest('.dropdown-menu')) {
              // Add a small delay before hiding the dropdown to improve user experience
              // when moving between menu items, especially when moving diagonally
              setTimeout(() => {
                // Only hide if the mouse is still outside the dropdown
                if (!this.dropdown.matches(':hover') &&
                    !this.dropdown.querySelector('.dropdown-menu')?.matches(':hover')) {
                  this.dropdownHide(this.dropdown);
                }
              }, 300);
            }
          });
        }
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.slideout-submenu');
    if (closeBtn) {
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
    
    // Focus management: If keyboard was used, focus first item
    // Otherwise, keep focus on toggle button for mouse users
    const firstFocusable = dropdownParent.querySelector('.dropdown-menu a[tabindex="0"], .dropdown-menu button[tabindex="0"], .dropdown-menu a:not([tabindex="-1"]), .dropdown-menu button:not([tabindex="-1"])');
    // Only auto-focus if dropdown was opened via keyboard (check if toggleCTA has focus)
    if (document.activeElement === this.toggleCTA && firstFocusable) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 50);
    }
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex && !ele.matches(':hover') &&
          !ele.querySelector('.dropdown-menu')?.matches(':hover')) {
          this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.querySelector('[data-trigger-video]') || this.container.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.placement == 'grid' && this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection.setAttribute('aria-hidden', 'false');
        if(this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video) {
    if (this.type === 'local') {
      video.play();
    } else if (this.type == 'youtube' || this.type == 'metafiled') {
      video.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      );
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type == 'youtube' || this.type == 'metafiled') {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;

    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      video.autoplay = true;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube' || this.type == 'metafiled'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=1&mute=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      // &playlist=${videoID}
    }
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
customElements.define("custom-video", CustomVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButtons = this.querySelectorAll('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButtons.forEach(btn => btn.removeEventListener('click', this.closeDrawer.bind(this)));
    this.removeEventListener('keydown', this.onKeyDown.bind(this));
    document.removeEventListener('keydown', this.onDocumentKeyDown);
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if(btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
          setTimeout(() => {
            (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
          }, 0);
        }else{
          (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
        }
        
      });
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        this.closeDrawer();
      });
    });
    this.addEventListener('keydown', this.onKeyDown.bind(this));
    // Bind document-level listener for better Esc key handling
    this.onDocumentKeyDown = this.onKeyDown.bind(this);
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyDown(evt) {
    // Check for Escape key using both key and code properties for better compatibility
    if (evt.key === 'Escape' || evt.key === 'Esc' || evt.code === 'Escape' || evt.keyCode === 27) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.isOpen) {
        this.closeDrawer();
      }
    }
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();

    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
    
    // Add document-level Esc key listener when drawer is open
    document.addEventListener('keydown', this.onDocumentKeyDown);
  }

  closeDrawer() {
      // Close any open dropdowns within this drawer FIRST, before closing the drawer
      // Find all dropdown elements (both by attribute and by class to be comprehensive)
      const allDropdowns = this.querySelectorAll('[is="drop-down"], .dropdown');
      const processedDropdowns = new Set();
      
      allDropdowns.forEach((dropdown) => {
        // Avoid processing the same element twice
        if (processedDropdowns.has(dropdown)) return;
        processedDropdowns.add(dropdown);
        
        // Only process if it has the "open" class
        if (dropdown.classList.contains('open')) {
          const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
          if (dropdownToggle) {
            dropdownToggle.setAttribute('aria-expanded', false);
          }
          dropdown.classList.remove('open');
        }
      });

      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      if (this.openedBy?.dataset.for == 'collection-sorting')
        this.classList.remove('collection-sorting');
      
      SiteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      
      // Remove document-level Esc key listener when drawer is closed
      document.removeEventListener('keydown', this.onDocumentKeyDown);
      
      this.openedBy = null;
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});


const tooltipBox = document.querySelector(".tooltips-box");
  const tooltip = document.querySelector(".tooltips");
  const tooltipClose = document.querySelector(".tooltips-close");

  if (tooltipBox && tooltip && tooltipClose) {
    // Show tooltip
    tooltipBox.addEventListener("click", () => {
      tooltip.classList.add("show");
    });

    // Hide tooltip on close button click
    tooltipClose.addEventListener("click", () => {
      tooltip.classList.remove("show");
    });

  }


setTimeout(() => {
  updateTopinRoot();
}, 300);
function updateTopinRoot() {
  let headerEle = document.querySelector(".section-header");
  if (headerEle != undefined) {
    let headerHeight = headerEle.clientHeight;
    document
      .querySelector(":root")
      .style.setProperty("--pe-navdrawer", `${headerHeight}px`);
    document
      .querySelector(":root")
      .style.setProperty("--pe-mobile-navdrawer", `${headerHeight}px`);
  }
  let topbarEle = document.querySelector(".topbar");
  if (topbarEle != undefined) {
    let topbarHeight = topbarEle.clientHeight;
    document.documentElement.style.setProperty(
      "--pe-topbar-height",
      `${topbarHeight}px`
    );
  }
  let footerEle = document.querySelector(".site-footer");
  if (footerEle != undefined) {
    let topbarHeight = footerEle.clientHeight;
    document.documentElement.style.setProperty(
      "--pe-footer-height",
      `${topbarHeight}px`
    );
  }
}